/** @format */

import React, { useState } from 'react'
import './companyPicker.css'
import { useDispatch, useSelector } from 'react-redux'
import { setCompany } from '../../redux/actions/companyAction'
import { Box } from '@mui/material'
import { useCheckFinalPrice } from 'Components/ActionTable/hooks/useCheckFinalPrice'
import { searchCompanyName } from 'Utils/functions'

function CompanyPicker({ show, setShow, home, companies }) {
  const channel = new BroadcastChannel('customer_display')
  const { checkFinalPrice } = useCheckFinalPrice()
  const dispatch = useDispatch()

  const company = useSelector(state => state?.company)

  const allWarehouses = useSelector(
    state => state?.login?.user?.CustomerInfo?.Warehouses
  )

  const customerId = useSelector(
    state => state.cotizacion?.QuoteHeader?.CustomerId
  )

  const [warehouseDefault, setWarehouseDefault] = useState({})
  const [selectedCompany, setSelectedCompany] = useState(company)

  const isCompanyValid = company =>
    company.CompanyId !== selectedCompany.CompanyId &&
    company?.IsVisibleInPortalVAD

  const handleChangeCompany = async company => {
    window.localStorage.setItem('company', searchCompanyName(company))
    setSelectedCompany(company)
    const warehouses = allWarehouses.filter(warehouse => {
      return warehouse.CompanyId === company.CompanyId
    })

    channel.postMessage({
      isChangeCompany: true,
      company: warehouses[0].CompanyId,
      branchOffice: warehouses[0].BranchOfficeId,
    })
    setWarehouseDefault(warehouses[0])
    dispatch(
      setCompany({
        CompanyCode: warehouses[0].CompanyCode,
        CompanyName: warehouses[0].CompanyName,
        CompanyId: warehouses[0].CompanyId,
        WarehouseCode: warehouses[0].WarehouseCode,
        WarehouseId: warehouses[0].WarehouseId,
        BranchOfficeId: warehouses[0].BranchOfficeId,
        WarehouseDescription: warehouses[0].WarehouseDescription,
        WarehouseName: warehouses[0].WarehouseName,
        WarehouseAddress: warehouses[0].WarehouseAddress,
        DefaultWarehouse: warehouses.length === 1,
        ProfileImage: company?.ProfileImage,
      })
    )
    await checkFinalPrice({ newCompany: warehouseDefault, customerId })

    channel.postMessage({
      company: warehouses[0].CompanyId,
      branchOffice: warehouses[0].BranchOfficeId,
      isChangeCompany: false,
    })
    setShow(false)
  }

  return (
    <Box
      component="div"
      className={show ? 'companypicker-menu' : 'companypicker-menu-off'}
      sx={{
        left: {
          xs: '0',
          sm: home ? '3px' : '75px',
        },
      }}
      data-testid="container-company-picker">
      <ul>
        {companies?.length &&
          companies
            .filter(company => isCompanyValid(company))
            .map((company, index) => (
              <>
                <li
                  className="company-element"
                  onClick={() => handleChangeCompany(company)}
                  data-testid={`btn-select-company-${index}`}>
                  <img src={company?.ProfileImage} alt="novey-logo" />
                </li>
              </>
            ))}
      </ul>
    </Box>
  )
}

export default CompanyPicker
